// extracted by mini-css-extract-plugin
export default {"wrapper":"BonusHunterPromotions_wrapper--_3v","image":"BonusHunterPromotions_image--EHL"};